import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	editIcon: {
		color: colors.gray[700],
		fontSize: "20px"
	},
	listItemButton: {
		background: colors.gray[100],
		opacity: "0.7",
		width: "64px",
		height: "64px",
		borderRadius: "8px",
		gap: "8px",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		}
	},
	listItemMoreOptions: {
		background: colors.gray[100],
		opacity: 0.8,
		borderRadius: "8px",
		gap: "8px",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		},
		minWidth: "64px",
		width: "64px",
		height: "64px",
		color: colors.gray[700],
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	}
}))

export default useStyles
